// COLORREF format: 0x00BBGGRR (little-endian BGR)

export function hexToColorref(hex: string): number {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return (b << 16) | (g << 8) | r;
}

export function colorrefToHex(colorref: number): string {
  const r = colorref & 0xff;
  const g = (colorref >> 8) & 0xff;
  const b = (colorref >> 16) & 0xff;
  return '#' + [r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('');
}

/** COLORREF를 "R, G, B" 형식 문자열로 */
export function colorrefToRgbString(colorref: number): string {
  const r = colorref & 0xff;
  const g = (colorref >> 8) & 0xff;
  const b = (colorref >> 16) & 0xff;
  return `${r}, ${g}, ${b}`;
}

/** 0x00RRGGBB (일반 RGB 정수)를 COLORREF로 변환 */
export function rgbToColorref(rgb: number): number {
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = rgb & 0xff;
  return (b << 16) | (g << 8) | r;
}
